import { BsCheckCircle } from "react-icons/bs";
import { FaCarSide, FaHelicopter, FaMotorcycle, FaTractor, FaTrailer } from "react-icons/fa";
import { GiBus, GiTruck } from "react-icons/gi";
import { RiTruckFill } from "react-icons/ri";

const colheitadeira = require("../../images/colheitadeira.png");
const colheitadeiraBranca = require("../../images/colheitadeiraBranca.png");
const colheitadeiraDisabled = require("../../images/colheitadeiraCinza.png");

const ProductChipsHistories = [
  {
    id: 'all',
    label: 'Selecionar todos',
    icon: (color: string) => <BsCheckCircle color={color} />,
  },
  {
    id: '1',
    label: 'Trator',
    icon: (color: string) => <FaTractor color={color} />,
    balanceKey: "tr_balance",
    countCompanyKey: "tr_count_company",
    countUserKey: "tr_count_user",
  },
  {
    id: '2',
    label: 'Helicóptero',
    icon: (color: string) => <FaHelicopter color={color} />,
    balanceKey: "hp_balance",
    countCompanyKey: "hp_count_company",
    countUserKey: "hp_count_user",
  },
  {
    id: '3',
    label: 'Semirreboque',
    icon: (color: string) => <FaTrailer color={color} />,
    balanceKey: "sr_balance",
    countCompanyKey: "sr_count_company",
    countUserKey: "sr_count_user",
  },
  {
    id: '4',
    label: 'Carroceria',
    icon: (color: string) => <RiTruckFill color={color} />,
    balanceKey: "cr_balance",
    countCompanyKey: "cr_count_company",
    countUserKey: "cr_count_user",
  },
  {
    id: '5',
    label: 'Caminhões e Ônibus',
    icon: (color: string, isSelected?: boolean, isCard?: boolean) => (
      <div style={{ display: 'flex', flexDirection: "column", }}>
        <GiTruck className={isCard ? 'translate-y-[4px]' : 'translate-y-6'} size={isCard ? 20 : 100} color={color} />
        <GiBus className={isCard ? '-translate-y-[4px]' : '-translate-y-6'} size={isCard ? 20 : 100} color={color} />
      </div>
    ),
    balanceKey: "cm_balance",
    countCompanyKey: "cm_count_company",
    countUserKey: "cm_count_user",
  },
  {
    id: '6',
    label: 'Colheitadeira',
    icon: (color: string, isSelected?: boolean, isCard?: boolean, isDisabled?: boolean) => (
      <img
        src={isCard && isSelected ? colheitadeiraBranca : isDisabled ? colheitadeiraDisabled : colheitadeira}
        alt="harvester"
        className={isCard ? 'p-3' : 'p-10 '}
      />
    ),
    balanceKey: "hv_balance",
    countCompanyKey: "hv_count_company",
    countUserKey: "hv_count_user",
    isHarvester: true,
  },
  {
    id: '7',
    label: 'Leves (0km)',
    icon: (color: string, isSelected?: boolean, isCard?: boolean) => (
      
      <div style={{ display: 'flex', flexDirection: "column", }}>
        <FaMotorcycle className={isCard ? 'translate-y-[2px]' : 'translate-y-4'} size={isCard ? 20 : 100} color={color} />
        <FaCarSide className={isCard ? '-translate-y-[2px]' : '-translate-y-4'} size={isCard ? 20 : 100} color={color} />
      </div>
    ),
    balanceKey: "lw_balance",
    countCompanyKey: "lw_count_company",
    countUserKey: "lw_count_user",
  },

];

export default ProductChipsHistories